/**
 * Takes an array and produces an iterable generator
 * that yields one element at a time until the end
 * is reached.
 */
export function* enqueue(array) {
    const copy = [...array];
    while (copy.length > 1) {
        yield copy.shift();
    }
    return copy.shift();
}
/**
 * Loops over a generator and performs the provided task on the yielded
 * value until the generator is done.
 */
export async function runTaskOnGenerator(generator, task) {
    const results = [];
    while (true) {
        const take = await generator.next();
        const [result] = await Promise.allSettled([task(take.value)]);
        results.push(result);
        if (take.done) {
            return results;
        }
    }
}
/**
 * Transforms an array into a queue and runs instances of a task in parallel
 * on the items in the queue.
 *
 * @example
 * // Uploads array of files with a maximum of 3 in parallel at a time
 * const results = await runParallelTasksOnQueue(
 *   [fileA, fileB, fileC, fileD, fileE],
 *   async (file) => uploadFile(file),
 *   3,
 * );
 */
export async function runParallelTasksOnQueue(array, task, maxRunners) {
    const numRunners = array.length > maxRunners ? maxRunners : array.length;
    const queue = enqueue(array);
    const results = (await Promise.all(Array.from({ length: numRunners }).map(() => runTaskOnGenerator(queue, task)))).flatMap((x) => x);
    return results;
}
//# sourceMappingURL=index.js.map